<h2 mat-dialog-title>Please confirm</h2>
<mat-dialog-content>
  @for (msg of (data.message || []); track msg) {
    <p>{{msg}}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onConfirm()" color="warn">{{ data.confirmLabel || 'OK' }}</button>
  <button mat-raised-button (click)="onCancel()">{{ data.cancelLabel || 'Cancel' }}</button>
</mat-dialog-actions>
